// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgStarFill24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M12.2212 2.68205C12.3199 2.73073 12.3998 2.81062 12.4485 2.90934L15.0845 8.25463L20.9827 9.10983C21.256 9.14946 21.4454 9.40312 21.4058 9.6764C21.39 9.78533 21.3387 9.886 21.2599 9.96281L16.9908 14.1216L18.0001 19.9954C18.0469 20.2676 17.8641 20.5261 17.592 20.5729C17.4835 20.5915 17.3719 20.5738 17.2745 20.5226L12 17.7476L6.72559 20.5226C6.48121 20.6512 6.17887 20.5573 6.05029 20.3129C5.99904 20.2155 5.98137 20.1039 6.00001 19.9954L7.00932 14.1216L2.74022 9.96281C2.54242 9.77012 2.53827 9.45356 2.73096 9.25576C2.80776 9.17692 2.90844 9.12563 3.01737 9.10983L8.91561 8.25463L11.5516 2.90934C11.6737 2.66167 11.9735 2.55991 12.2212 2.68205Z" />
			</Svg>
		);
	}
);
SvgStarFill24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgStarFill24;
